import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const container = css`
  margin: 0 auto;
  position: relative;
  z-index: 5;

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      max-width: ${pxToRem(684)};
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.L, max: maxBreakpoints.L },
    css`
      max-width: ${pxToRem(388)};
    `,
  )};
  ${mediaQuery(
    { min: minBreakpoints.M, max: maxBreakpoints.M },
    css`
      max-width: ${pxToRem(386)};
      min-width: ${pxToRem(300)};
    `,
  )};
  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      padding: 0 ${spacing.xs}px;
    `,
  )};

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      margin: 0;
      width: 100%;
      max-width: none;
      flex: 1;
      min-width: 0;
    `,
  )};
`;

export const removeRightSpacing = css`
  margin: 0 0 0 auto;

  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      padding: 0 0 0 ${spacing.xs}px;
    `,
  )};
`;
